import { Vue, Component } from 'vue-property-decorator';
import { readUserProfile } from '@/store/main/getters';
import { IUserProfile } from '@/interfaces';
import { store } from '@/store';
import { readHasAdminAccess } from '@/store/main/getters';

@Component
export default class PrivilegeMixin extends Vue {
  // This call checks the privileges against the user record roles
  public roleCheck(prKey: string, privRequired: string) {
    const rec: IUserProfile | null = readUserProfile(this.$store);
    if (rec && rec.roles && rec.roles[prKey]) {
      const privUser = rec.roles[prKey];
      if (privRequired === 'Manage') {
        return privUser === 'Manage';
      } else if (privRequired === 'Write') {
        return privUser === 'Write' || privUser === 'Manage';
      } else if (privRequired === 'Read') {
        return (
          privUser === 'Read' || privUser === 'Write' || privUser === 'Manage'
        );
      }
    } else {
      if (rec && rec.roles) {
        return false;
      } else {
        // No roles
        return true;
      }
    }
  }

  public isSuperUser() {
    return readHasAdminAccess(store);
  }
}
